export default "__VITE_ASSET__DUYN$dbG__"